module.exports = __webpack_public_path__ + "img/icon_yjh.08dc8ff8.png";